import coreIcons from './icons';

export default class CoreIconsProvider {
  public static mergeIcons(icons: any): void {
    Object.assign(icons, coreIcons);
  }
}
